import styled, { css } from 'styled-components';

import { flexCenterAligned } from '@/styles/common';

type ChipStyleConfig = {
  color: string;
  border: string;
  background: string;
  borderHover: string;
  backgroundHover: string;
};

const getChipConfig = (
  isLight: boolean,
  isPremium: boolean
): ChipStyleConfig => {
  const baseConfig = {
    dark: {
      color: 'var(--textAndLabels-dark)',
      border: 'var(--system-white)',
      borderHover: 'var(--system-white)',
      background: 'var(--bg-tertiary)',
      backgroundHover: 'var(--brand-main)'
    },
    light: {
      color: 'var(--textAndLabels-main)',
      border: 'var(--border-dark)',
      borderHover: 'var(--border-dark)',
      background: 'var(--bg-tertiary)',
      backgroundHover: 'var(--brand-main)'
    }
  };

  const config = isLight ? baseConfig.light : baseConfig.dark;

  if (isPremium) {
    return {
      ...config,
      border: 'var(--bg-premium)',
      borderHover: 'var(--bg-premium)',
      background: 'var(--bg-secondary)',
      backgroundHover: 'var(--bg-secondary)',
      color: 'var(--textAndLabels-main)'
    };
  }

  return config;
};

export const Chip = styled.label<{
  $isSelected: boolean;
  $isPremium: boolean;
  $isLight: boolean;
}>`
  ${flexCenterAligned}
  width: fit-content;
  gap: 5px;
  height: 40px;
  padding: 12px 15px;
  border-radius: 50px;
  border: 1px solid
    ${({ $isSelected }) =>
      $isSelected ? 'var(--selected-chip-border)' : 'var(--border-main)'};
  background-color: ${({ $isSelected }) =>
    $isSelected ? 'var(--selected-chip-bg)' : 'var(--bg-secondary)'};
  color: var(--textAndLabels-main);
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: var(--selected-chip-bg);
    border-color: var(--selected-chip-border);
  }

  ${({ $isSelected, $isLight, $isPremium }) => {
    const { color, border, background, borderHover, backgroundHover } =
      getChipConfig($isLight, $isPremium);
    return css`
      border: ${$isSelected
        ? `1px solid ${border}`
        : '1px solid var(--border-secondary)'};
      background-color: ${$isSelected ? background : 'var(--bg-main)'};
      color: ${$isSelected ? color : 'var(--textAndLabels-main)'};

      &:hover {
        background-color: ${$isSelected
          ? backgroundHover
          : 'var(--bg-secondary)'};
        border-color: ${borderHover};
        color: ${!$isPremium && $isSelected
          ? 'var(--textAndLabels-dark)'
          : 'var(--textAndLabels-main)'};
      }
    `;
  }}

  cursor: pointer;
  transition:
    background-color 0.3s ease,
    border-color 0.3s ease,
    color 0.3s ease;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Input = styled.input`
  position: absolute;
  width: 1;
  height: 1;
  opacity: 0;
`;
